﻿import { projectSettings } from "../../config";

import LandingPage from "./LandingPage.svelte";
import DocumentUpload from "./DocumentUpload.svelte";
import ThankYou from "./ThankYou.svelte";

const title = "South Australia Sunday Shift Class Actions Investigation";

export const documentUploadPageList = [
	{
		pageIndex: 0,
		component: LandingPage,
		title: "Document Upload Form",
		showInTracker: true,
		routeId: "/FileUpload",
		nextPage: "/FileUpload/DocumentUpload",
		properties: {
			pageTitle: `${title}`
		}
	},
	{
		pageIndex: 1,
		component: DocumentUpload,
		title: "Document Upload",
		showInTracker: true,
		routeId: "/FileUpload/DocumentUpload",
		nextPage: "/FileUpload/ThankYou",
		previousPage: "/FileUpload",
		properties: {
			pageTitle: `${title} - Document Upload`,
			persistUrl: `/api/file-upload-submit`
		}
	},
	{
		pageIndex: 2,
		component: ThankYou,
		title: "Document Upload Submitted",
		showInTracker: false,
		routeId: "/FileUpload/ThankYou",
		properties: {
			pageTitle: `${title} - Thank you`
		}
	}
];

export default documentUploadPageList;
